import { Branding } from '../enums';

const BRANDING_STORAGE_KEY = 'branding';
const TITLE_STORAGE_KEY = 'title';
const LEARN_AND_EARN_DOMAIN = 'learnandearn.school';
const LEARN_AND_EARN_TITLE = 'Learn & Earn';

const BRANDING_TITLE: Record<Branding, string> = {
  [Branding.LearnAndEarn]: LEARN_AND_EARN_TITLE,
};

const BRANDING_DOMAIN: Record<Branding, string> = {
  [Branding.LearnAndEarn]: LEARN_AND_EARN_DOMAIN,
};

let branding: Branding;
let title: string;

export function getBranding(): Branding {
  if (!branding) {
    branding = sessionStorage.getItem(BRANDING_STORAGE_KEY) as Branding;
  }
  return branding || Branding.LearnAndEarn;
}

export function getTitle(): string {
  if (!title) {
    title = sessionStorage.getItem(TITLE_STORAGE_KEY);
  }
  return title || LEARN_AND_EARN_TITLE;
}

export function detectCurrentBranding(): Branding {
  let branding: Branding;
  const urlParams = new URLSearchParams(window.location.search);
  let brandingParam: string | null = urlParams.get('branding');
  if (brandingParam) {
    brandingParam = brandingParam.toLowerCase();
  }

  if (
    brandingParam === Branding.LearnAndEarn.toLowerCase() ||
    window.location.host.toLowerCase().endsWith(LEARN_AND_EARN_DOMAIN.toLowerCase())
  ) {
    branding = Branding.LearnAndEarn;
  } else {
    branding = (sessionStorage.getItem(BRANDING_STORAGE_KEY) as Branding) || Branding.LearnAndEarn;
  }
  return branding;
}

export function applyBranding(): void {
  const branding: Branding = detectCurrentBranding();
  sessionStorage.setItem(BRANDING_STORAGE_KEY, branding);

  const title = BRANDING_TITLE[branding] || LEARN_AND_EARN_TITLE;
  sessionStorage.setItem(TITLE_STORAGE_KEY, title);

  document.title = `${title} Dashboard`;
  document.body.classList.add(`branding-${branding.toLowerCase()}`);
  const faviconLink: HTMLLinkElement = document.querySelector("link[rel='icon']") as HTMLLinkElement;
  if (faviconLink) {
    faviconLink.href = `assets/dashboard/icons/${branding.toLowerCase()}-icon.png`;
  }
}

export function getProductUrlBasedOnBranding(): string {
  const branding: Branding = getBranding();
  const domain = BRANDING_DOMAIN[branding] || LEARN_AND_EARN_DOMAIN;
  return `https://dashboard.${domain}/`;
}
